/* eslint-disable @typescript-eslint/no-explicit-any */
import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const DEDUPE_WINDOW_MS = 4000;
const recentErrors = new Map<string, number>();

export const rtkErrorLogger: Middleware = () => (next) => (action: any) => {

  const isSilent = action?.meta?.arg?.originalArgs?.isSilent;

  if (isRejectedWithValue(action) && !isSilent) {
    const message =
      action?.payload?.response?.data?.message ||
      action?.payload?.data?.message ||
      action?.payload?.message ||
      'Something went wrong';

    const now = Date.now();
    const lastShownAt = recentErrors.get(message);

    if (!lastShownAt || now - lastShownAt > DEDUPE_WINDOW_MS) {
      recentErrors.set(message, now);
      toast.error(message, { toastId: `rtk-error:${message}` });

      if (recentErrors.size > 50) {
        recentErrors.forEach((ts, key) => {
          if (now - ts > DEDUPE_WINDOW_MS) recentErrors.delete(key);
        });
      }
    }
  }
  return next(action);
};

